import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteProductPayload } from '@app-store/slices/products/deleteProduct'

interface TaskAction extends Action {
    payload: IDeleteProductPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.products.delete

function* deleteProductSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/companies/products/${payload.productId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Product deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteProductSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteProductSagaTask)
}

export default deleteProductSaga
